import React, { useState } from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import CardPresetConfigDrawer from "../../components/admin/CardPresetConfigDrawer";
import CardSettingsTable from "../../components/admin/cards/CardSettingsTable";
import DeleteCardSettingsModal from "../../components/admin/DeleteCardSettingsModal";
import { TablePage } from "@outpave/ds";
import { useNavBreadcrumbs } from "hooks/useNavBreadcrumbs";

const CardSettings: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumbs = useNavBreadcrumbs(t("Card Settings"));

  const [openDeleteCardSettingsModal, setOpenDeleteCardSettingsModal] =
    useState<boolean>(false);

  const [refreshPresets, setRefreshPresets] = useState(0);

  const handleRefreshPresets = () => {
    setRefreshPresets((prev) => prev + 1);
  };

  const [selectedId, setSelectedId] = useState<string>("");

  const [openCardPresetDrawer, setOpenCardPresetDrawer] =
    useState<boolean>(false);

  const handleCloseDrawer = (isReloadData = false) => {
    if (isReloadData) {
      handleRefreshPresets();
    }
    setSelectedId("");
    setOpenCardPresetDrawer(false);
    setOpenDeleteCardSettingsModal(false);
  };

  const handleOpenCardPresetConfigDrawer = () => {
    setOpenCardPresetDrawer(true);
  };

  const handleDeleteButton = (id: string) => {
    setSelectedId(id);
    setOpenDeleteCardSettingsModal(true);
  };

  const handleEditButton = (id: string) => {
    setSelectedId(id);
    setOpenCardPresetDrawer(true);
  };

  return (
    <TablePage
      title={t("Card Settings")}
      breadcrumbs={breadcrumbs}
      primaryAction={
        <Button onClick={handleOpenCardPresetConfigDrawer}>
          {t("Add configuration")}
        </Button>
      }
    >
      <CardSettingsTable
        handleEditButton={handleEditButton}
        handleDeleteButton={handleDeleteButton}
        refreshPresets={refreshPresets}
      />

      <CardPresetConfigDrawer
        selectedId={selectedId}
        open={openCardPresetDrawer}
        handleCloseDrawer={handleCloseDrawer}
      />
      <DeleteCardSettingsModal
        open={openDeleteCardSettingsModal}
        handleCloseModal={handleCloseDrawer}
        selectedId={selectedId}
      />
    </TablePage>
  );
};

export default CardSettings;
